var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.4791 11.625H24.5416V9.04165C24.5416 4.05603 20.4857 0 15.5 0C10.5143 0 6.45835 4.05603 6.45835 9.04165V11.625H4.52085C4.16387 11.625 3.875 11.9139 3.875 12.2709V28.4167C3.875 29.8414 5.03356 31 6.45835 31H24.5417C25.9664 31 27.125 29.8414 27.125 28.4166V12.2709C27.125 11.9139 26.8361 11.625 26.4791 11.625ZM17.4337 25.1162C17.4539 25.2985 17.3953 25.4814 17.2729 25.6183C17.1506 25.7551 16.9752 25.8334 16.7917 25.8334H14.2084C14.0248 25.8334 13.8495 25.7551 13.7271 25.6183C13.6048 25.4815 13.5461 25.2985 13.5663 25.1162L13.9737 21.4525C13.3121 20.9713 12.9167 20.2101 12.9167 19.375C12.9167 17.9503 14.0753 16.7916 15.5001 16.7916C16.9249 16.7916 18.0834 17.9502 18.0834 19.375C18.0834 20.2101 17.688 20.9713 17.0264 21.4525L17.4337 25.1162ZM20.6666 11.625H10.3334V9.04165C10.3334 6.19279 12.6511 3.875 15.5 3.875C18.3489 3.875 20.6666 6.19279 20.6666 9.04165V11.625Z",
    fill: "url(#paint0_linear_193_1534)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_1534",
    x1: 3.875,
    y1: 15.5,
    x2: 27.1258,
    y2: 15.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F0098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD35DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.86e56c6998cd5bcb5b572a10f1b13bc7.svg";
export { ForwardRef as ReactComponent };